export default function removeDuplicateStrings(...params) {
	const input = params
		.filter(Boolean)
		.reduce((reduction, item) => [...reduction, ...item.split(',').map(i => i.trim())], []);

	return Array.from(new Set(input));
}
